import { Dialog, DialogContent, Grid, Paper, Typography } from "@mui/material";
import { useState } from "react";
import { useMutation } from "react-query";
import styled from "styled-components/macro";
import ButtonMenu from "../../components/custom/ButtonMenu";
import PrimaryButton from "../../components/custom/PrimaryButton";
import {
  stripeCheckoutProduct,
  stripeInvoiceProduct,
} from "../../services/upgradeYourPlan";
import MoneyPerMonth from "./MoneyPerMonth";
import MessageDialog from "../../components/custom/MessageDialog";
import { customerPortalInfo } from "../../services/portalService";

const StyledPaper = styled(Paper)`
  margin-top: 0.5rem;
  max-width: 100%;
  border-radius: 1.5rem;
  padding: 0.5rem;
  background-color: ${(props) => props.theme.palette.background.default};
  height: 100%;
`;

const ProductCard = ({ data }) => {
  const customer = JSON.parse(window.sessionStorage.getItem("customer"));
  const publisherSubscriptionInfo = JSON.parse(
    window.sessionStorage.getItem("publisherSubscriptionInfo")
  );
  const [openDialog, setOpenDialog] = useState(false);

  const [dialogConfig, setDialogConfig] = useState({
    open: false,
    message: "Billing information is missing!",
    hint: "Invoice cannot be generated beacuse your billing information is missing. Please click on the Update button and fill all necessary fields.",
    action: () => updateBillingInformation(publisherSubscriptionInfo),
  });

  const updateBillingInformation = async (publisherSubscriptionInfo) => {
    setOpenDialog(true);
    await customerPortalInfo(publisherSubscriptionInfo);
    setOpenDialog(false);
  };

  const { mutate } = useMutation(stripeCheckoutProduct, {
    onSuccess: (data) => {
      //  navigate("/paymentSuccess");
      setOpenDialog(false);
    },
    onError: (error) => {
      switch (error) {
        default: {
          alert("error");
        }
      }
    },
  });
  const { mutate: mutateInvoice } = useMutation(stripeInvoiceProduct, {
    onSuccess: (data) => {
      //  navigate("/paymentSuccess");
      setOpenDialog(false);
    },
    onError: (error) => {
      console.log(error);
      setOpenDialog(false);
      if (error?.response?.status === 424) {
        setDialogConfig((prev) => ({
          ...prev,
          open: true,
        }));
      }
      // switch (error) {
      //   default: {
      //     alert("error");
      //   }
      // }
    },
  });
  const handleBuyNow = () => {
    setOpenDialog(true);
    const map = new Map();
    map.set("publisherId", customer?.publisherId);
    mutate({
      customerId: customer?.stripeId,
      productId: data?.productId,
      priceId: data?.priceId,
      parametersMap: {
        publisherId: customer?.publisherId,
        name: data?.name,
        price: data?.price,
        descr: data?.description,
      },
    });
  };

  const handleCreateInvoice = () => {
    setOpenDialog(true);
    const map = new Map();
    map.set("publisherId", customer?.publisherId);
    mutateInvoice({
      customerId: customer?.stripeId,
      productId: data?.productId,
      priceId: data?.priceId,
      parametersMap: {
        publisherId: customer?.publisherId,
        name: data?.name,
        price: data?.price,
      },
    });
  };
  return (
    <>
      <StyledPaper>
        <Grid container direction={"column"} spacing={2}>
          <Grid item>{data?.name}</Grid>
          <Grid item>
            <Typography>
              Fulfillments:{" "}
              {data?.booksFulfillments == 1
                ? "select your quantity (min.10)"
                : data?.booksFulfillments}
            </Typography>
          </Grid>
          <Grid item>
            <MoneyPerMonth
              price={data?.price}
              perDescription={
                data?.booksFulfillments == 1 ? "/Unit" : "/Package"
              }
            />
          </Grid>
          <Grid item>
            {data?.booksFulfillments != 1 && (
              <ButtonMenu
                menuName="Buy"
                menuDisabled={false}
                menuSingleItem={false}
                menuCardAction={() => handleBuyNow()}
                menuBankAction={
                  () => handleCreateInvoice()
                  // setTimeout(() => setOpenDialog(false), 4000);
                }
              />
            )}
            {data?.booksFulfillments == 1 && (
              <PrimaryButton onClick={handleBuyNow}>Buy</PrimaryButton>
            )}
          </Grid>
        </Grid>
      </StyledPaper>
      <Dialog open={openDialog}>
        <DialogContent>Redirecting to billing portal</DialogContent>
      </Dialog>
      <MessageDialog
        dialogConfig={dialogConfig}
        setDialogConfig={setDialogConfig}
      />
    </>
  );
};

export default ProductCard;
